/**
 * MultiStepForm Type
 *
 * Show/hide specific elements in reusable form steps components
 */
export enum FormType {
  GRANT_PLAN = 'GRANT_PLAN',
  PLAN_SUBSCRIPTION = 'PLAN_SUBSCRIPTION',
  PRE_PROVISION_SIM = 'PRE_PROVISION_SIM',
}
